<template>
  <ul class="radio-list">
    <li v-for="(g, groupKey) in groups" :key="groupKey">
      <input :id="`id_${answer['id']}_group_${groupKey + 1}`" type="radio" @change="change" :value="g" v-model="current"
        :name="`id_${answer['id']}_group`" />
      <label :for="`id_${answer['id']}_group_${groupKey + 1}`"><span>{{ g }} </span></label>
    </li>
  </ul>
</template>

<script>

export default {
  props: ['answer', 'value'],
  created() {
      if (this.value){
        this.current = this.value;
      }
  },
  methods: {
    change() {

      this.$emit('input', this.current);
    }
  },
  data: () => ({
    current: null,
    groups: [
      'A',
      'B',
      'C',
      'D',
      'E',
      'F',
      'G',
      'H',
    ],
  }),
};
</script>
<style lang="scss">
ul.radio-list {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -5px;

  &>li {
    position: relative;
    max-width: calc(100% / 8);
    min-width: calc(100% / 8);
    padding: 5px;

    &>label {
      width: 100%;
      height: 0;
      padding-top: 100%;
      border: 2px solid #ebebeb;
      position: relative;
      border-radius: 10px;

      &>span {
        display: block;
        position: absolute;
        font-size: 16px;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }

    &>input[type=radio] {
      opacity: 0;
      position: absolute;

      &:checked~label {
        border-color: orange;
      }
    }
  }
}
</style>
